import React from "react";

import Single from "./singlePro";
import { Heading, Box,Hide,Show} from "@chakra-ui/react";
import Textst from "../animate/textAnimate";
import Zoom from "react-reveal/Zoom";
import ProjectSmall from "./projectSmall"
let prs = [
  {
    img: "https://i.ytimg.com/vi/f2JsUPv9m8s/hqdefault.jpg",
    detail:
      "zoomcar is an online car booking and car rental application, where one can take cars on rent.This application was built by a team of five members",
    head: "Zoomcar.com",
    deploy: "https://magical-kashata-a20ef2.netlify.app/",
    github: "https://github.com/zuhedshaikh95/Zoomcar-Clone",
  },
  {
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToYIsuz_fZKtaDVH0rQBGgQEqJO0er5unmww&usqp=CAU",
    detail:
      "Zara.com in an online shopping and product based application, where we can enjoy endless shopping. The project was built by 4 members within 5 days.",
    head: "Zara.com",
    deploy: "https://meek-faun-0874a4.netlify.app/",
    github:
      "https://github.com/mira713/zara.com/tree/main/zara.com/public-bead-6343",
  },
  {
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnoZxhOfQYDis6ZrUGn5jYk4rkL8b5TLzieg&usqp=CAU",
    detail:
      "Reliance Mart is an online shopping mart application, where one can purchase a variety of items. This project was built within a time span of 5 days.",
    head: "Reliance Mart",
    deploy: "https://melodic-syrniki-172917.netlify.app/",
    github: "https://github.com/Sonia-saini/-accidental-visitor-9960",
  },
  {
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNpmSZbJKYt47nXb2dngqLfEojidLaTp1-0A&usqp=CAU",
    detail:
      "1 MG is an online medicine merchant application, where one can buy different medicines. This Project was built by 4 members within a time span of 4 days.",
    head: "1 MG",
    deploy: "https://medical-hub-zeta.vercel.app/",
    github: "https://github.com/mira713/medicine-hub",
  },
];
const Projects = () => {
  return (
    <div id="project">
      
      <Box border="1px solid orangered" m="auto" w="80%"></Box>
      <br />
      <Heading textAlign={"center"} color="orangered" p="1rem" fontSize={['22px','3xl','3xl','3xl']}>
        <u>
          <Textst text="MY   AWESOME   PROJECTS" />
        </u>
      </Heading>
      <br />
      <Hide below="sm">
      <Box boxShadow="dark-lg" h="auto" w="70%" m="auto" p="50px">
        {prs.map((pr) => {
          return (
            <Box key={pr.head} style={{ marginTop: "5em" }} p="10px">
              <Zoom>
                <Single
                  img={pr.img}
                  details={pr.detail}
                  head={pr.head}
                  deploy={pr.deploy}
                  github={pr.github}
                />
              </Zoom>
            </Box>
          );
        })}
      </Box>
      </Hide>
      <Show below="sm">
        {prs.map((el)=><Zoom><ProjectSmall img={el.img} detail={el.detail} head={el.head} github={el.github} deploy={el.deploy}/></Zoom>)}
      </Show>
    </div>
  );
};

export default Projects;
